import React from 'react';

// 마지막 방어선 (CLAUDE.md Phase 8): 렌더링·커밋 중 오류가 나도 흰 화면 대신 복구하거나 안내를 보여 준다.
// 첫 오류는 자식 트리를 새로 그려 자동 복구한다(번역기·확장 프로그램이 DOM 을 건드려 생긴 일회성 충돌이면 이것으로 끝난다).
// 자동 복구는 10초에 한 번까지. 그 안에 또 실패하면 안내 화면을 보여 준다
const AUTO_RECOVER_INTERVAL_MS = 10000;

class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, generation: 0 };
    this.lastRecoveryAt = 0;
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch() {
    const now = Date.now();
    if (now - this.lastRecoveryAt > AUTO_RECOVER_INTERVAL_MS) {
      this.lastRecoveryAt = now;
      this.setState((s) => ({ hasError: false, generation: s.generation + 1 }));
    }
  }

  handleRetry = () => {
    this.lastRecoveryAt = Date.now();
    this.setState((s) => ({ hasError: false, generation: s.generation + 1 }));
  };

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          role="alert"
          className="min-h-screen flex items-center justify-center px-4 bg-orange-50 text-gray-900 [@media(prefers-color-scheme:dark)]:bg-gray-900 [@media(prefers-color-scheme:dark)]:text-white"
        >
          <div className="max-w-md text-center space-y-4">
            <p className="text-lg font-bold break-keep">화면을 표시하지 못했습니다</p>
            <p className="text-sm break-keep">
              브라우저의 번역 기능이나 확장 프로그램이 페이지를 바꾸면 이런 일이 생길 수 있습니다. 다시 시도하거나 새로고침해 주세요.
            </p>
            <div className="flex justify-center gap-3">
              <button
                type="button"
                onClick={this.handleRetry}
                className="px-4 py-2 rounded-lg bg-orange-500 text-white font-medium cursor-pointer hover:bg-orange-600"
              >
                다시 시도
              </button>
              <button
                type="button"
                onClick={this.handleReload}
                className="px-4 py-2 rounded-lg border-2 border-orange-300 font-medium cursor-pointer hover:bg-orange-100 [@media(prefers-color-scheme:dark)]:hover:bg-gray-800"
              >
                새로고침
              </button>
            </div>
          </div>
        </div>
      );
    }
    // generation 이 바뀌면 key 가 달라져 자식 트리를 처음부터 다시 만든다(번역기가 바꿔 놓은 DOM 을 버린다)
    return <React.Fragment key={this.state.generation}>{this.props.children}</React.Fragment>;
  }
}

export default AppErrorBoundary;
